import type { TOC } from '@ember/component/template-only';
import { PrismIcon } from '@mylighthouse/prism-ember';

interface HotelMarketInsightListsListItemsListItemEventSignature {
  Args: {
    event: unknown;
  };
}

const HotelMarketInsightListsListItemsListItemEvent = <template>
  {{! @glint-nocheck: not typesafe yet }}
  <span class="mr-200">
    <PrismIcon @name={{@event.icon}} @size="small" />
  </span>
  <div class="flex flex-col">
    <p class="event-name text-300--bold">{{@event.name}}</p>
    <div class="event-info mt-200 flex flex-row">
      <span class="mr-100">
        <PrismIcon @name="calendar-accepted" @size="small" />
      </span>
      <p class="text-300--regular">{{@event.formattedDays}}</p>
    </div>
    {{#if @event.location}}
      <div class="event-info mt-200 flex flex-row items-center">
        <span class="mr-100">
          <PrismIcon @name="location-pin" @size="small" />
        </span>
        <p class="text-300--regular">{{@event.location}}</p>
      </div>
    {{/if}}
  </div>
</template> satisfies TOC<HotelMarketInsightListsListItemsListItemEventSignature>;

export default HotelMarketInsightListsListItemsListItemEvent;
